exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".p-postWordsCounter__num[data-v-1dcfcbf5]{font-size:1.1rem;letter-spacing:2px}", "", {"version":3,"sources":["/home/circleci/repo/app/components/postEditor/parts/PostWordsCounter.vue"],"names":[],"mappings":"AA+CE,0CACE,iBACA,kBAAA,CAAA","file":"PostWordsCounter.vue?vue&type=style&index=0&id=1dcfcbf5&scoped=true&lang=sass&","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.p-postWordsCounter\n  &__num\n    font-size: 1.1rem\n    letter-spacing: 2px\n"],"sourceRoot":""}]);

// exports
